"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("../../components/Pages/LandingPage/LandingPage");
var LandingPage_1 = require("../../components/Pages/LandingPage/LandingPage");
var Index = function () {
    return React.createElement(LandingPage_1.default, null);
};
exports.default = Index;
